import * as THREE from 'three';

export default class MoveObject{
	constructor() {
		this.boundingBox = [];
	}

	/// Pour déplacer via le bouton de l'ui
	MoveObject(objects, data) {
		for(var i = 0; i < objects.length; i++) {
				if (!objects[i].simsData.moved) {
					objects[i].simsData.basePos.x = objects[i].position.x;
					objects[i].simsData.basePos.y = objects[i].position.y;
					objects[i].simsData.basePos.z = objects[i].position.z;
				}
				
				objects[i].position.x += data.x;
				objects[i].position.y += data.y;
				objects[i].position.z += data.z;

				objects[i].simsData.moved = true;
		}
	}

	MoveObjectOffsetPosition(objects, objectOffset, data) {
		if (!objects.simsData.moved) {
			objects.simsData.basePos.x = objects.position.x;
			objects.simsData.basePos.y = objects.position.y;
			objects.simsData.basePos.z = objects.position.z;
		}

		var newYPos = this.ObjectInBoundingBox(objects);
		
		objects.position.x = objectOffset.x + data.x;
		objects.position.y = newYPos;

		objects.position.z = objectOffset.z + data.z;

		objects.simsData.moved = true;
	}

	MoveObjectToPos(object, data) {
		if (!object.simsData.moved) {
			object.simsData.basePos.x = object.position.x;
			object.simsData.basePos.y = object.position.y;
			object.simsData.basePos.z = object.position.z;
		}
		
		object.position.x = data.x;
		object.position.y = data.y;
		object.position.z = data.z;

		object.simsData.moved = true;
	}

	RotateObject(objects, data) {
		for(var i = 0; i < objects.length; i++) {
			if (!objects[i].simsData.rotated) {
				objects[i].simsData.baseRot.x = objects[i].rotation.x;
				objects[i].simsData.baseRot.y = objects[i].rotation.y;
				objects[i].simsData.baseRot.z = objects[i].rotation.z;
			}
			
			objects[i].rotation.x += data.x;
			objects[i].rotation.y += data.y;
			objects[i].rotation.z += data.z;

			objects[i].simsData.rotated = true;
		}
	}

	RotObjectToRot(object, data) {
		if (!object.simsData.moved) {
			object.simsData.baseRot.x = object.rotation.x;
			object.simsData.baseRot.y = object.rotation.y;
			object.simsData.baseRot.z = object.rotation.z;
		}
		
		object.rotation.x = data.x;
		object.rotation.y = data.y;
		object.rotation.z = data.z;

		object.simsData.rotated = true;
	}

	RotateObjectFromDegree(objects, data) {
		var dataToApply = this.DataToDegree(data);
		for(var i = 0; i < objects.length; i++) {
			if (!objects[i].simsData.rotated) {
				objects[i].simsData.baseRot.x = objects[i].rotation.x;
				objects[i].simsData.baseRot.y = objects[i].rotation.y;
				objects[i].simsData.baseRot.z = objects[i].rotation.z;
			}

			
			objects[i].rotation.x = dataToApply.x;
			objects[i].rotation.y = dataToApply.y;
			objects[i].rotation.z = dataToApply.z;

			objects[i].simsData.rotated = true;
		}
	}

	ResetPosObject(objects) {
		for(var i = 0; i < objects.length; i++) {
			if (objects[i].simsData.moved) {
				objects[i].position.x = objects[i].simsData.basePos.x;
				objects[i].position.y = objects[i].simsData.basePos.y;
				objects[i].position.z = objects[i].simsData.basePos.z;
				objects[i].simsData.moved = false;
			}
		}
	}

	ResetRotObject(objects) {
		for(var i = 0; i < objects.length; i++) {
			if (objects[i].simsData.rotated) {
				objects[i].rotation.x = objects[i].simsData.baseRot.x;
				objects[i].rotation.y = objects[i].simsData.baseRot.y;
				objects[i].rotation.z = objects[i].simsData.baseRot.z;
				objects[i].simsData.rotated = false;
			}
		}
	}

	DataToDegree(data) {
		var dataToReturn = {};
		dataToReturn.x = data.x * (Math.PI / 180);
		dataToReturn.y = data.y * (Math.PI / 180);
		dataToReturn.z = data.z * (Math.PI / 180);

		return dataToReturn;
	}

	ResetObject(objects) {
		this.ResetPosObject(objects);
		this.ResetRotObject(objects);
	}

	GetBoundingSurelevation(sceneChildrens) {
		this.boundingBox = [];
		var box;
		if (sceneChildrens.length > 0 && sceneChildrens[0].parent.parent.name == "Lully") {
			var objBox = sceneChildrens[0].parent.parent.getObjectByName("Scene_Bord");
			if(objBox) {
				box = new THREE.Box3().setFromObject(objBox);
				this.boundingBox.push(box);
			}
		}

		for (var i = 0; i < sceneChildrens.length; i++) {
			if (sceneChildrens[i].name == "Praticable" && sceneChildrens[i].visible) {
				box = new THREE.Box3().setFromObject(sceneChildrens[i]);
				box.max.x -= sceneChildrens[i].parent.parent.position.x;
				box.min.x -= sceneChildrens[i].parent.parent.position.x;
				this.boundingBox.push(box);
				/*const helper = new THREE.Box3Helper(box, 0xff0000); // Rouge
				sceneChildrens[0].parent.add(helper);*/
			}
		}
	}

	ObjectInBoundingBox(obj) {
		var posYToReturn = 0;
		for (var i = 0; i < this.boundingBox.length; i++) {
			if (obj.position.x < this.boundingBox[i].max.x && obj.position.x > this.boundingBox[i].min.x && obj.position.z < this.boundingBox[i].max.z && obj.position.z > this.boundingBox[i].min.z) {
				posYToReturn = this.boundingBox[i].max.y;
				console.log(this.boundingBox[i])
			}
		}

		return posYToReturn;
	}

	CheckProximity(objToCheck, objectList, avoidObjectList, offset) {
		var data = {position: {}};
		data.snap = false;
		data.snapX = false;
		data.snapZ = false;
		data.position.x = 0;
		data.position.z = 0;
		//var objToCheckBox = new THREE.Box3().setFromObject(objToCheck);
		//var refBox;
		for (var i = 0; i < objectList.length; i++) {
			if (objectList[i] != objToCheck && objectList[i].name == objToCheck.name && !avoidObjectList.includes(objectList[i])) {
				data = this.CheckXProximity(objToCheck, objectList[i], offset, data);
				data = this.CheckZProximity(objToCheck, objectList[i], offset, data);
			}
		}

		return data;
	}

	CheckXProximity(objToCheck, objectToCompare, offset, data) {
		var objToCheckBox = new THREE.Box3().setFromObject(objToCheck);
		var refBox = new THREE.Box3().setFromObject(objectToCompare);

		if (objToCheck.name == "Chaise_Bleue" && (objToCheck.rotation.y == 0 || objToCheck.rotation.y == Math.PI)) {
			if (objToCheckBox.min.x - refBox.max.x < offset && objToCheckBox.min.x - refBox.max.x > 0 && !data.snapX) {
				data.snap = true;
				data.snapX = true;
				data.position.x = objectToCompare.position.x + (refBox.max.x - refBox.min.x) + 0.01;
			}
			else if (objToCheckBox.max.x - refBox.min.x < offset && objToCheckBox.max.x - refBox.min.x > 0 && !data.snapX) {
				data.snap = true;
				data.snapX = true;
				data.position.x = objectToCompare.position.x - (refBox.max.x - refBox.min.x) - 0.01;
			}
		}
		else {
			if (objToCheck.position.x - objectToCompare.position.x < offset && objToCheck.position.x - objectToCompare.position.x > -offset && !data.snapX) {
				data.snap = true;
				data.snapX = true;
				data.position.x = objectToCompare.position.x;
			}
		}

		return data;
	}

	CheckZProximity(objToCheck, objectToCompare, offset, data) {
		var objToCheckBox = new THREE.Box3().setFromObject(objToCheck);
		var refBox = new THREE.Box3().setFromObject(objectToCompare);

		if (objToCheck.rotation.y == 0 || objToCheck.rotation.y == Math.PI || objToCheck.name != "Chaise_Bleue") {
			if (objToCheck.position.z - objectToCompare.position.z < offset && objToCheck.position.z - objectToCompare.position.z > -offset && !data.snapZ) {
				data.snap = true;
				data.snapZ = true;
				data.position.z = objectToCompare.position.z;
			}
		}
		else {
			if (objToCheckBox.min.z - refBox.max.z < offset && objToCheckBox.min.z - refBox.max.z > 0 && !data.snapZ) {
				data.snap = true;
				data.snapZ = true;
				data.position.z = objectToCompare.position.z + (refBox.max.z - refBox.min.z) + 0.01;
			}
			else if (objToCheckBox.max.z - refBox.min.z < offset && objToCheckBox.max.z - refBox.min.z > 0 && !data.snapZ) {
				data.snap = true;
				data.snapZ = true;
				data.position.z = objectToCompare.position.z - (refBox.max.z - refBox.min.z) - 0.01;
			}
		}

		return data;
	}
}